import { NgModule } from '@angular/core';
import { MomentPipe } from './moment/moment.pipe';
import { AlterOrderPipe } from './alterOrder/alter-order.pipe';
import { TimestampPipe } from './timestamp/timestamp.pipe';
import { PluralPipe } from './plural/plural.pipe';
import { NumberSuffixPipe } from './numberSuffix/number-suffix.pipe';
import { FormatDatePipe } from './formatDate/format-date.pipe';
import { FilterItemsByNamePipe } from './filterItemsByName/filter-items-by-name.pipe';
import { SopoDatePipe } from './sopoDate/sopo-date.pipe';
import { BountyFormatLabelPipe } from './bountyFormatLabel/bounty-format-label.pipe';
import { ChipAmountPipe } from './chipAmount/chip-amount.pipe';
@NgModule({
    declarations: [
        MomentPipe,
        AlterOrderPipe,
        TimestampPipe,
        PluralPipe,
        NumberSuffixPipe,
        FormatDatePipe,
        FilterItemsByNamePipe,
        SopoDatePipe,
        BountyFormatLabelPipe,
        ChipAmountPipe,
    ],
    imports: [],
    providers: [NumberSuffixPipe],
    exports: [
        MomentPipe,
        AlterOrderPipe,
        TimestampPipe,
        PluralPipe,
        NumberSuffixPipe,
        FormatDatePipe,
        FilterItemsByNamePipe,
        SopoDatePipe,
        BountyFormatLabelPipe,
        ChipAmountPipe,
    ]
})
export class SharedPipesModule {}
